/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowUiAuthLoginIcon16Light } from './ArrowUiAuthLoginIcon16Light';
import { ArrowUiAuthLoginIcon16Regular } from './ArrowUiAuthLoginIcon16Regular';
import { ArrowUiAuthLoginIcon16Solid } from './ArrowUiAuthLoginIcon16Solid';
import { ArrowUiAuthLoginIcon20Light } from './ArrowUiAuthLoginIcon20Light';
import { ArrowUiAuthLoginIcon20Regular } from './ArrowUiAuthLoginIcon20Regular';
import { ArrowUiAuthLoginIcon20Solid } from './ArrowUiAuthLoginIcon20Solid';
import { ArrowUiAuthLoginIcon24Regular } from './ArrowUiAuthLoginIcon24Regular';
import { ArrowUiAuthLoginIcon24Solid } from './ArrowUiAuthLoginIcon24Solid';
import { ArrowUiAuthLoginIcon32Regular } from './ArrowUiAuthLoginIcon32Regular';
import { ArrowUiAuthLoginIcon64Regular } from './ArrowUiAuthLoginIcon64Regular';
var sizes = {
    16: {
        light: ArrowUiAuthLoginIcon16Light,
        regular: ArrowUiAuthLoginIcon16Regular,
        solid: ArrowUiAuthLoginIcon16Solid,
    },
    20: {
        light: ArrowUiAuthLoginIcon20Light,
        regular: ArrowUiAuthLoginIcon20Regular,
        solid: ArrowUiAuthLoginIcon20Solid,
    },
    24: {
        regular: ArrowUiAuthLoginIcon24Regular,
        solid: ArrowUiAuthLoginIcon24Solid,
    },
    32: {
        regular: ArrowUiAuthLoginIcon32Regular,
    },
    64: {
        regular: ArrowUiAuthLoginIcon64Regular,
    },
};
export var ArrowUiAuthLoginIcon = forwardRef('ArrowUiAuthLoginIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
